export {
  lint,
  type Diagnostic,
  type Fix,
  type LintFixResult,
  type LintOptions
} from "./lint/index.js";
